import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import withModal from '../../../../../components/global/modal/withModal';
import DismissButton from '../../../../../components/global/DismissButton';
import { ALBUM_SUBTYPE } from '../../../../../constants/albums';
import WaldofiedFeatureComparison from './WaldofiedFeatureComparison';

const propTypes = {
  className: PropTypes.string,
  waldofiedEventAddonItem: PropTypes.shape({
    id: PropTypes.string,
    price: PropTypes.shape({
      value: PropTypes.number.isRequired,
    }),
  }).isRequired,
  onRequestClose: PropTypes.func,
  onClose: PropTypes.func,
};

export const WALDOFIED_FEATURE_COMPARISON =
  'modal/WALDOFIED_FEATURE_COMPARISON';

const WaldofiedFeatureComparisonModal = ({
  className,
  onClose,
  onRequestClose,
  waldofiedEventAddonItem,
  eventType = ALBUM_SUBTYPE.CUSTOM_EVENT,
}) => {
  const classes = classNames({
    [className]: !!className,
  });

  return (
    // This will catch any unexpected click on the modal which would trigger
    // the parent, a toggle-able button, from toggling unintentionally.

    <div
      tabIndex={0}
      role="button"
      className={classes}
      onClick={event => event.stopPropagation()}
    >
      <div className="mb-1 text-right">
        <DismissButton onClick={onClose || onRequestClose} />
      </div>
      <h3 className="text-center">Event album feature comparison</h3>
      <WaldofiedFeatureComparison
        waldofiedEventAddonItem={waldofiedEventAddonItem}
        eventType={eventType}
      />
    </div>
  );
};

WaldofiedFeatureComparisonModal.propTypes = propTypes;

export default withModal(WaldofiedFeatureComparisonModal, {
  name: WALDOFIED_FEATURE_COMPARISON,
  overlayClassName: 'waldofied-features-comparison-overlay',
  dismissible: false,
  hideHeader: true,
  type: 'full',
  size: 'md',
});
